/**
 * Keep document manifest link in sync with current URL (SPA navigation).
 *
 * @module client/lib/sync-pwa-manifest
 */
import {
  buildPwaStartUrlFromLocation,
  getPwaManifestHref,
} from "../../lib/pwa-manifest";

function getManifestLink(): HTMLLinkElement | null {
  const link = document.querySelector('link[rel="manifest"]');
  return link instanceof HTMLLinkElement ? link : null;
}

/**
 * Update or create the manifest link for the current location.
 */
export function syncPwaManifestFromLocation(): void {
  if (typeof window === "undefined") {
    return;
  }

  const startPath = buildPwaStartUrlFromLocation(
    window.location.pathname,
    new URLSearchParams(window.location.search),
  );
  const href = getPwaManifestHref(startPath);

  let link = getManifestLink();
  if (!link) {
    link = document.createElement("link");
    link.rel = "manifest";
    document.head.appendChild(link);
  }

  if (link.getAttribute("href") !== href) {
    link.setAttribute("href", href);
  }
}
